import React, { useMemo, useEffect, useState, useContext } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import { Chart } from 'react-charts';
import { ThemeContext } from './ThemeContext';

export default function ItemLiquidityGraph(props) {
	const [graphData, setGraphData] = useState(null);
	const primaryAxis = useMemo(
		(): AxisOptions<MyDatum> => ({
			getValue: datum => datum.x,
		}),
		[]
	)

	const secondaryAxes = useMemo(
		(): AxisOptions<typeof data[number]["data"][number]>[] => [
			{
				show: false,
				getValue: datum => datum.y,
				scaleType: "linear",
				showDatumElements: true,
			}
		],
		[]
	)

	useEffect(() => {
		async function getGraphPoints() {
		    let suppliesToQuery = [...Array(props.item.currentSupply + 40).keys()].map(x => x + 1);
		    let pricesAtSupplies = await Promise.all(suppliesToQuery.map(async (supplyToQuery) => {
		      let price = await encryptUtils.computeCurrentPrice(props.item.tokenId, supplyToQuery, props.item.protocol);
		      return (price / 1000000000000000000).toFixed(3);
		    }));
		    let values = [];
		    for(let i = 0; i < suppliesToQuery.length; i++) {
		    	let supplyToQuery = suppliesToQuery[i];
		    	let price = pricesAtSupplies[i];
				values.push({
					'x': supplyToQuery,
					'y': price,
				});
		    }
			let data = [
				{
					label: "Price in ETH",
					data: values
				}
			]
			setGraphData(data);
		}
		getGraphPoints();
	}, [props.item]);

	const { theme } = React.useContext(ThemeContext);

	if(graphData == null) {
		return null;
	} else {
		return (
		    <div className="w-80 sm:w-112"
		      style={{
		        height: '60px'
		      }}
		    >
				<Chart
					options={{
						data: graphData,
						primaryAxis,
						secondaryAxes,
						dark: theme === 'dark',
						getDatumStyle: (datum) => {
							return ({
								circle: { r: datum.originalDatum.x === props.item.currentSupply ? 5 : 0 },
							});
						}
					}}
				/>
			</div>
		);
	}
}
